import { Modal, Button, Input } from "antd";
import React from "react";
import { Formik } from "formik";

export class AddIPModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: true,
    };
  }

  handleSubmit = (values, { setSubmitting }) => {
    this.props.onSubmit && this.props.onSubmit(values);
    setSubmitting(false);
  };

  handleCancel = () => {
    this.setState({ visible: false });
    this.props.onCancel && this.props.onCancel();
  };

  validateForm = (values) => {
    const errors = {};
    if (!values.ip_address) {
      errors.ip_address = "IP Address is required";
    } else {
      const ipRegex =
        /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;
      if (!ipRegex.test(values.ip_address)) {
        errors.ip_address = "Invalid IP Address format";
      }
    }
    return errors;
  };

  render() {
    return (
      <Modal
        destroyOnClose
        title="Add IP"
        open={this.state.visible}
        onCancel={this.handleCancel}
        footer={null}
      >
        <Formik
          initialValues={{ ip_address: "" }}
          validate={this.validateForm}
          onSubmit={this.handleSubmit}
        >
          {({
            values,
            errors,
            touched,
            handleChange,
            handleBlur,
            handleSubmit,
            isSubmitting,
          }) => (
            <form onSubmit={handleSubmit}>
              <div style={{ marginBottom: "12px" }}>
                IP Address
                <Input
                  id="ip_address"
                  name="ip_address"
                  placeholder="Enter IP Address"
                  value={values.ip_address}
                  onChange={handleChange}
                  onBlur={handleBlur}
                />
                {errors.ip_address && touched.ip_address && (
                  <p style={{ color: "red", fontSize: "small", margin: 0 }}>
                    {errors.ip_address}
                  </p>
                )}
              </div>
              <Button
                htmlType="submit"
                style={{ background: "#5C6AC4", color: "#fff" }}
                disabled={isSubmitting}
              >
                Save
              </Button>
            </form>
          )}
        </Formik>
      </Modal>
    );
  }
}
